/**
 * @generated SignedSource<<200c062c662b5dcfe55a7f1bbf5760a1>>
 * @relayHash 3ef0d2cd0ec92fcb79b05bd2174f0f67
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dc35c66493f7bdc19a49975dafbf453dce49ec4e7eb631c51bc060205199faa9

import type { ConcreteRequest, Query } from 'relay-runtime';
export type mainGroupByDropdownContentQuery$variables = {
  nodeId: string;
};
export type mainGroupByDropdownContentQuery$data = {
  readonly node: {
    readonly __typename: "JiraGroupedListView";
    readonly id: string;
    readonly viewSettings: {
      readonly canEnableGrouping: boolean | null | undefined;
      readonly groupByConfig: {
        readonly __id: string;
        readonly availableGroupByFieldOptions: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly fieldId: string;
              readonly id: string;
              readonly name: string;
            };
          } | null | undefined> | null | undefined;
        };
      };
      readonly isGroupingEnabled: boolean | null | undefined;
    };
  } | {
    readonly __typename: "JiraListView";
    readonly id: string;
    readonly viewSettings: {
      readonly canEnableGrouping: boolean | null | undefined;
      readonly groupByConfig: {
        readonly __id: string;
        readonly availableGroupByFieldOptions: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly fieldId: string;
              readonly id: string;
              readonly name: string;
            };
          } | null | undefined> | null | undefined;
        };
      };
      readonly isGroupingEnabled: boolean | null | undefined;
    };
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
};
export type mainGroupByDropdownContentQuery = {
  response: mainGroupByDropdownContentQuery$data;
  variables: mainGroupByDropdownContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "nodeId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "nodeId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "canEnableGrouping"
},
v5 = {
  "kind": "ScalarField",
  "name": "isGroupingEnabled"
},
v6 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "name"
},
v8 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v9 = {
  "kind": "ScalarField",
  "name": "__id"
},
v10 = [
  {
    "kind": "RequiredField",
    "field": (v3/*: any*/),
    "action": "THROW",
    "path": "node.id"
  },
  {
    "kind": "RequiredField",
    "field": {
      "concreteType": "JiraIssueSearchViewConfigSettings",
      "kind": "LinkedField",
      "name": "viewSettings",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v5/*: any*/),
        {
          "kind": "RequiredField",
          "field": {
            "concreteType": "JiraSpreadsheetGroupByConfig",
            "kind": "LinkedField",
            "name": "groupByConfig",
            "plural": false,
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "args": (v6/*: any*/),
                  "concreteType": "JiraSpreadsheetGroupByFieldOptionConnection",
                  "kind": "LinkedField",
                  "name": "availableGroupByFieldOptions",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraSpreadsheetGroupByFieldOptionEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": {
                            "concreteType": "JiraField",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "kind": "RequiredField",
                                "field": (v7/*: any*/),
                                "action": "THROW",
                                "path": "node.viewSettings.groupByConfig.availableGroupByFieldOptions.edges.node.name"
                              },
                              {
                                "kind": "RequiredField",
                                "field": (v8/*: any*/),
                                "action": "THROW",
                                "path": "node.viewSettings.groupByConfig.availableGroupByFieldOptions.edges.node.fieldId"
                              }
                            ]
                          },
                          "action": "THROW",
                          "path": "node.viewSettings.groupByConfig.availableGroupByFieldOptions.edges.node"
                        }
                      ]
                    }
                  ],
                  "storageKey": "availableGroupByFieldOptions(first:10)"
                },
                "action": "THROW",
                "path": "node.viewSettings.groupByConfig.availableGroupByFieldOptions"
              },
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": (v9/*: any*/),
                    "action": "THROW",
                    "path": "node.viewSettings.groupByConfig.__id"
                  }
                ]
              }
            ]
          },
          "action": "THROW",
          "path": "node.viewSettings.groupByConfig"
        }
      ]
    },
    "action": "THROW",
    "path": "node.viewSettings"
  }
],
v11 = [
  {
    "concreteType": "JiraIssueSearchViewConfigSettings",
    "kind": "LinkedField",
    "name": "viewSettings",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      (v5/*: any*/),
      {
        "concreteType": "JiraSpreadsheetGroupByConfig",
        "kind": "LinkedField",
        "name": "groupByConfig",
        "plural": false,
        "selections": [
          {
            "args": (v6/*: any*/),
            "concreteType": "JiraSpreadsheetGroupByFieldOptionConnection",
            "kind": "LinkedField",
            "name": "availableGroupByFieldOptions",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraSpreadsheetGroupByFieldOptionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraField",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ]
                  }
                ]
              }
            ],
            "storageKey": "availableGroupByFieldOptions(first:10)"
          },
          {
            "kind": "ClientExtension",
            "selections": [
              (v9/*: any*/)
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "mainGroupByDropdownContentQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v10/*: any*/),
            "type": "JiraGroupedListView"
          },
          {
            "kind": "InlineFragment",
            "selections": (v10/*: any*/),
            "type": "JiraListView"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "mainGroupByDropdownContentQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v11/*: any*/),
            "type": "JiraGroupedListView"
          },
          {
            "kind": "InlineFragment",
            "selections": (v11/*: any*/),
            "type": "JiraListView"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "dc35c66493f7bdc19a49975dafbf453dce49ec4e7eb631c51bc060205199faa9",
    "metadata": {},
    "name": "mainGroupByDropdownContentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "910c423bd110046eb5deacf45ae573d5";

export default node;
